import { cloneDeep, sum } from 'lodash';
import type { ITableLayer } from '@/version-types';

/** 检查表格数据是否符合规范 */
export const checkTableNumberIsValid = (layer: ITableLayer) => {
    const checkNumber = (num: number) => Number.isInteger(num) && num > 0;
    const { vertical: vSizes } = layer.data.baseCells;
    // 横向尺寸暂不修复，取整会放大历史数据的宽度偏差。
    return vSizes.every(checkNumber) && checkNumber(layer.width) && checkNumber(layer.height);
};

/** 修复表格数据 */
export const getFixedTableNumber = (layer: ITableLayer): ITableLayer => {
    const fixNumber = Math.ceil;

    const newLayer = cloneDeep(layer);

    newLayer.width = fixNumber(newLayer.width);

    const baseCells = newLayer.data.baseCells;
    const oldVSizeAcc = sum(baseCells.vertical);
    baseCells.vertical = baseCells.vertical.map(fixNumber);
    const newVSizeAcc = sum(baseCells.vertical);
    const deltaOfHeight = newVSizeAcc - oldVSizeAcc;
    newLayer.height = fixNumber(newLayer.height + deltaOfHeight);

    return newLayer;
};
